import React from 'react';
import MenuCliente from '../Components/MenuCliente/menucliente';
import './historico.css';

function Historico(){
    return <div>      
      <MenuCliente />      
    </div>;
  }

export default Historico;